let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8viSX")).then(() => parcelRequire('1vNAm'));